module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Bold.62d4d7d.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Bold.otf
// module id = CM3d
// module chunks = 1